(function(){
    'use strict';
    angular.module('app').controller('ServiceProfilePreviewController', ServiceProfilePreviewController);
    
    ServiceProfilePreviewController.$inject = [
        '$routeParams',
        '$location',
        '$q',
        '$filter',
        '$uibModal',
        'Carrier',
        'ClientService',
        'Currency',
        'ServicesService',
        'toastr',
        'ServiceProfilePreviewTableService',
        'Location',
        'CarrierLoadRatesTableService',
        'LoadingModalFactory'
    ];
    
    function ServiceProfilePreviewController(
        $routeParams,
        $location,
        $q,
        $filter,
        $uibModal,
        Carrier,
        ClientService,
        Currency,
        ServicesService,
        toastr,
        ServiceProfilePreviewTableService,
        Location,
        CarrierLoadRatesTableService,
        LoadingModalFactory
    ) {
        let vm = this;
        vm.serviceId = $routeParams.id;
        vm.clientService = {};
        vm.recipients = [];
        vm.cc = [];
        vm.emailHistory = {};
        vm.raw = {};
        vm.addRecipients = addRecipients;
        vm.addCC = addCC;
        vm.removeRecipient = removeRecipient;
        vm.removeCC = removeCC;
        vm.previewBeforeSend = previewBeforeSend;
        vm.back = back;
        vm.serviceProfile = {};
        init();
        function init() {
            getClientServiceProfile().then(data=>{
                vm.raw = data;
                vm.serviceProfile = data.serviceProfile;
                vm.clientService = mapServiceProfileDetails(data);
                vm.zonPostCodeMargins = mapZonePostcodeBaseMarginsData(data);
                
                getPreviewHistoryData(data.id).then(data=>{
                    vm.emailHistory = mapHistoryData(data);
                });

                getRatesData(data.serviceProfile);
            });
        }
        function getClientServiceProfile() {
            const defer = $q.defer();

            ServicesService.getClientServiceLink(vm.serviceId, function (data) {
                defer.resolve(data);
            }, function (err) {
                defer.reject(err);
                toastr.error('Margin not found', '404');
            });
            return defer.promise;
        }
        function getRatesData(serviceProfile) {
            if(angular.getObjVal(serviceProfile, 'service.rateCategories')) {
                angular.forEach(serviceProfile.service.rateCategories, rateType=>{
                    rateType.table = new CarrierLoadRatesTableService(angular.copy(serviceProfile), {isPreview: true, rateType}).tableData;
                });
            }
        }
        function getPreviewHistoryData(serviceProfileId){
            const defer = $q.defer();
            ClientService.Client.getHistory(function(data){
                defer.resolve(data);
            }, function(error){
                defer.reject(error);
                toastr.error(error.message, error.code);
            },serviceProfileId);
            return defer.promise;
        }
        function mapServiceProfileDetails(data) {
            let serviceProfileDetailsData =  {
                profileName: data.name,
                carrierProfile: angular.getObjVal(data, 'carrierProfile.name'),
                carrierProfileId: angular.getObjVal(data, 'carrierProfile.id'),
                serviceProfile: angular.getObjVal(data, 'serviceProfile.name'),
                serviceProfileId: angular.getObjVal(data, 'serviceProfile.id'),
                companies: data.companyOffices ? data.companyOffices.map(company=>{
                    return { name: company.name, id: company.id };
                }): [],
                globalMargins: {
                    fixed: $filter('bbaCurrency')(data.marginMinValue, data.currency),
                    percent: angular.getObjVal(data, 'marginPercent') ? `${angular.getObjVal(data, 'marginPercent')}%` : '0%'
                }
            }
            // The api returns a very inconsistent data XD
            if(data.serviceProfile){
                if(data.serviceProfile.fuelLevy !== null) {
                    serviceProfileDetailsData.fuelLevy = {
                        enabled: angular.getObjVal(data, 'serviceProfile.fuelLevy.enabled') ? 'ENABLED' : 'DISABLED',
                    }
                    if(data.serviceProfile.fuelLevy.details) {
                        serviceProfileDetailsData.fuelLevy.fixed = $filter('bbaCurrency')(data.serviceProfile.fuelLevy.details.fixed, data.currency);
                        serviceProfileDetailsData.fuelLevy.percent =  angular.getObjVal(data, 'serviceProfile.fuelLevy.details.percentage') ? `${angular.getObjVal(data, 'serviceProfile.fuelLevy.details.percentage')}%`  : '0%';
                    }
                    else {
                        serviceProfileDetailsData.fuelLevy.fixed = $filter('bbaCurrency')(0, data.currency);
                        serviceProfileDetailsData.fuelLevy.percent = '0%';
                    }
                }
            }
            return serviceProfileDetailsData;
        }
        function mapZonePostcodeBaseMarginsData(data) {
            let mappedData =  {
                tpl: '/templates/directives/cards/zone-postcode-card.html',
                class: 'scrollable-list-card-bordered',
                enabled: angular.getObjVal(data, 'zoneMargins.enabled') ? 'ENABLED' : 'DISABLED',
                data: []
            }

            if(data.zoneMargins !== null) {
                if(angular.getObjVal(data, "zoneMargins.regions")) {
                    mappedData.data = data.zoneMargins.regions.map(region=>{
                        return {
                            from: `${angular.getObjVal(region.zoneFrom.country, 'name')} ( ${angular.getObjVal(region.zoneFrom, 'name')} )`,
                            to: `${angular.getObjVal(region.zoneTo.country, 'name')} ( ${angular.getObjVal(region.zoneTo, 'name')} )`,
                            marginFixed: angular.getObjVal(region, 'marginFixed') ? `${angular.getObjVal(region, 'marginFixed')} ${data.currency}` : `0 ${data.currency}`,
                            percent: angular.getObjVal(region, 'marginPercent') ? `${angular.getObjVal(region, 'marginPercent')}%` : `0%`
                        }
                    });
                }
            }
            return mappedData;
        }
        function mapHistoryData(data) {
            let historyData = {
                tpl: '/templates/directives/cards/sent-email-card.html',
                data: []
            };

            if(historyData.length !== 0) {
               historyData.data =  data.content.map(value=>{
                    return {
                        date: $filter('date')(value.createdDate),
                        to: value.recipients ? value.recipients.join(', ') : 'N/A',
                        cc: value.cc ? value.cc.join(', ') : 'N/A'
                    }
               });
            } 
            return historyData;
        }
        function addRecipients(data, form) {
            if(!angular.isUndefined(data) && !form.$invalid) {
                if(!hasDuplicate(data, vm.recipients) && !hasDuplicate(data, vm.cc)){
                    let tmpData = {label: data};
                    vm.recipients.push(tmpData);
                    vm.recipientEmail= '';
                    form.recipient.$setUntouched();
                }else {
                    toastr.clear();
                    toastr.warning("Email is already in the list", "FORM ERRORS");
                }
            } 
        }
        function addCC(data, form){
            if(!angular.isUndefined(data) && !form.$invalid) {
                if(!hasDuplicate(data, vm.cc) && !hasDuplicate(data, vm.recipients)){
                    let tmpData = {label: data};
                    vm.cc.push(tmpData);
                    vm.ccEmail= '';
                    form.cc.$setUntouched();
                }else {
                    toastr.clear();
                    toastr.warning("Email is already in the list", "FORM ERRORS");
                }
            } 
        }
        function hasDuplicate(needle, hayStack) {
            let dup = hayStack.filter(val=>{
                return needle === val.label;
            });
            return dup.length !== 0 ? true : false;
        }
        function removeRecipient(item) {
            let newData = vm.recipients.filter(val=>{
                return item.$$hashKey !== val.$$hashKey;
            });
            vm.recipients = newData;
        }
        function removeCC(item){
            let newData = vm.cc.filter(val=>{
                return item.$$hashKey !== val.$$hashKey;
            });
            vm.cc = newData;
        }
        function previewBeforeSend() {
            if(vm.recipients.length === 0) {
                toastr.clear();
                toastr.warning('Please add a recipient.', 'FORM ERROR');
                return false;
            }

            let modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                windowClass: 'r-c-p-modal previewModal marginPreviewModal',
                backdrop  : 'static',
                keyboard  : false,
                templateUrl: '/templates/pages/services/add-ons/previewModal.html',
                controller: 'PreviewModalController',
                controllerAs: 'vm',
                size: 'lg',
                appendTo: $('body'),
                resolve: {
                    ServiceProfile: function(){
                        return vm.serviceProfile;
                    },
                    clientServiceData: function(){
                        return vm.raw;
                    },
                    recipients: function() {
                        return vm.recipients;
                    },
                    cc: function() {
                        return vm.cc;
                    }
                }
            });

            modalInstance.result.then(function(data) {
                if(data){
                    vm.cc = [];
                    vm.recipients = [];
                    getPreviewHistoryData(vm.raw.id).then(data=>{
                        vm.emailHistory = mapHistoryData(data);
                    });
                }
            });
        }
        function back() {
            $location.path(`margins/view/${vm.serviceId}`);
        }
    }
})()



// WEBPACK FOOTER //
// ./js/controllers/services/ServiceProfilePreviewController.js